import { mixed, object, string } from "yup";

import type { I18nT } from "@lib/dashboardI18n";
import sharedConstants from "@lib/shared_constants";

export const getRcsFallbackMessageSchema = (t: I18nT<"rcs-composer">) =>
  object({
    fallback_message: object({
      type: mixed<"text">().oneOf([sharedConstants.RCS.FALLBACK_TYPES.TEXT]),
      body: string()
        .maxLengthIgnoringLiquid(
          sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_FALLBACK_TEXT,
          t("rcs-fallback-message-max-length-error", "Fallback message exceeds the character limit")
        )
        .nullable()
        .optional(),
    }).optional(),
  });
